import Backbone from 'backbone';

var UserGameStatusModel = Backbone.Model.extend({
  url: 'playing',

  parse: function (res) {
    return res.result.isPlaying;
  },

  checkPlaying: function (game) {
    return this.fetch({ game: game })
      .then(this.parse)
      .fail(function () {
        return false;
      });
  }
});

export var userGameStatus = new UserGameStatusModel();
